import {
  handleSubmit as handleSubmitBase,
  closeModalSafely as closeModalSafelyBase,
} from '../modals.service';
import { getLocaleHierarchy } from '../../../../utility/util/util.service';
import Collapse from '../../collapsables/collapse/collapse.component';
import LocalizedNameField from '../../form/fields/LocalizedNameField';
import LocalizedDescriptionField from '../../form/fields/LocalizedDescriptionField';
import React from 'react';
import * as PropTypes from 'prop-types';
import LocalizedCategoryField from '../../form/fields/LocalizedCategoryField';

export const closeModalSafely = closeModalSafelyBase;

export const handleSubmit = (
  event,
  errors,
  values,
  targetAddition,
  isEditMode,
  setIsSubmitting,
  setTargetAddition,
  closeModal,
  onSubmit,
  orderConditions,
  newOrderCondition,
  isAddOrderConditionOpen,
  storeId,
) =>
  handleSubmitBase(
    'item-additions/food',
    'editAdditionSuccess',
    'editAdditionError',
    'createNewAdditionSuccess',
    'createNewAdditionError',
    event,
    errors,
    {
      ...values,
      orderConditions: isAddOrderConditionOpen
        ? [...(orderConditions || []), newOrderCondition]
        : orderConditions,
      manualRanking: undefined,
      maxQty: parseInt(values?.maxQty || '1'), // form passes a string, backend expects integer
      ingredients: undefined,
      preferences: undefined,
      allergens: undefined,
      image: undefined,
    },
    targetAddition,
    isEditMode,
    setIsSubmitting,
    setTargetAddition,
    closeModal,
    onSubmit,
    storeId,
  );

export const getTranslationsCollapsable = (
  targetData,
  setTargetData,
  isTranslationsOpen,
  setIsTranslationsOpen,
  showDescriptionField = false,
  showNameField = true,
  showCategoryField = true,
  intlLocale,
) => {
  const localeHierarchy = getLocaleHierarchy(intlLocale);
  const additionalLocales = localeHierarchy.slice(1); // slice the first one

  return (
    <Collapse
      isOpen={isTranslationsOpen}
      setIsOpen={setIsTranslationsOpen}
      titleId="itemTranslationsTitle"
    >
      {additionalLocales.map((locale, index) => {
        if (locale !== intlLocale.toUpperCase()) {
          return (
            <div key={index}>
              {showNameField && (
                <LocalizedNameField object={targetData} locale={locale} />
              )}
              {showCategoryField && (
                <LocalizedCategoryField
                  locale={locale}
                  object={targetData}
                  setter={setTargetData}
                />
              )}
              {showDescriptionField && (
                <>
                  <LocalizedDescriptionField
                    object={targetData}
                    locale={locale}
                  />
                  <hr className="mb-2 mt-50" />
                </>
              )}
            </div>
          );
        }
      })}
    </Collapse>
  );
};
